import React from "react"

const scoreColor = (value) => {
  if (value == null) return "#494949"
  if (value >= 80) return "#2E7D32"
  if (value >= 50) return "#E65100"
  return "#C62828"
}

const KpiCard = ({ label, value, format = "number", color, subtitle }) => {
  const resolvedColor = format === "score" ? scoreColor(value) : (color || "#494949")

  const displayValue = () => {
    if (value == null) return "--"
    switch (format) {
      case "percent":
      case "score":
        return `${Number(value).toFixed(0)}%`
      case "decimal":
        return Number(value).toFixed(1)
      case "number":
      default:
        return Number(value).toLocaleString()
    }
  }

  return (
    <div
      style={{
        border: "1px solid #E5E5E5",
        borderRadius: "10px",
        backgroundColor: "#fff",
        padding: "16px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "90px",
        transition: "box-shadow 0.15s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(64,119,117,0.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
    >
      <p
        style={{
          fontSize: "11px",
          color: "#707070",
          fontWeight: "500",
          margin: "0 0 6px 0",
          textTransform: "uppercase",
          letterSpacing: "0.3px",
        }}
      >
        {label}
      </p>
      <h3
        style={{
          color: resolvedColor,
          fontSize: "28px",
          fontWeight: "700",
          margin: "0",
          lineHeight: "1",
        }}
      >
        {displayValue()}
      </h3>
      {subtitle && (
        <p style={{ fontSize: "10px", color: "#999", margin: "4px 0 0", lineHeight: "1.2" }}>
          {subtitle}
        </p>
      )}
    </div>
  )
}

const NetZeroSingleCard = ({ year }) => (
  <div
    style={{
      border: "1px solid #E5E5E5",
      borderRadius: "10px",
      backgroundColor: "#fff",
      padding: "16px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "90px",
    }}
  >
    <p style={{ fontSize: "11px", color: "#707070", fontWeight: "500", margin: "0 0 6px 0", textTransform: "uppercase", letterSpacing: "0.3px" }}>
      Net Zero Target
    </p>
    {year ? (
      <h3 style={{ color: "#407775", fontSize: "28px", fontWeight: "700", margin: "0", lineHeight: "1" }}>{year}</h3>
    ) : (
      <h3 style={{ color: "#AAAAAA", fontSize: "18px", fontWeight: "600", margin: "0", lineHeight: "1" }}>No target set</h3>
    )}
  </div>
)

const KpiCards = ({ kpis, dataset = "csrd" }) => {
  const isNiftyLike = dataset === "nifty" || dataset === "all"

  if (isNiftyLike) {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        <KpiCard label="Companies" value={kpis.company_count} />
        <KpiCard label="Avg Renewable Energy" value={kpis.average_csrd_page_count} format="percent" />
        {kpis.company_count === 1 ? (
          <NetZeroSingleCard year={kpis.net_zero_target_year} />
        ) : (
          <KpiCard
            label="Net Zero Targets"
            value={kpis.net_zero_count}
            format="number"
            subtitle={`of ${kpis.company_count} companies`}
          />
        )}
      </div>
    )
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "12px",
        marginBottom: "16px",
      }}
    >
      <KpiCard label="Companies" value={kpis.company_count} />
      <KpiCard label="Avg CSRD Pages" value={kpis.average_csrd_page_count} format="decimal" />
      <KpiCard label="Avg Material Topics" value={kpis.average_material_topics_count} format="decimal" />
      <KpiCard
        label="External Assurance"
        value={kpis.external_assurance_percent}
        format="percent"
        color="#407775"
      />
    </div>
  )
}

export default KpiCards
